import auth from 'b2b-common/services/auth'

import publicView from './index'
import loginView from './login'

export default {
  path: 'pub',
  name: 'Public/Default',
  component: publicView,
  redirect: { name: 'Public/Login' },
  beforeEnter: (to, from, next) => {
    auth.isLoggedIn().then(isLoggedIn => {
      if (isLoggedIn) next({ name: 'Private/Default' })
      else next()
    }, function () {
      next()
    })
  },
  children: [
    {
      path: 'login',
      name: 'Public/Login',
      component: loginView
    }
  ]
}
